import { QRCodeCanvas } from "qrcode.react";
import { FaApple, FaArrowRight, FaCheck, FaGooglePlay } from "react-icons/fa";
import { FiDownload, FiMail, FiSmartphone } from "react-icons/fi";
import { useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import superStudentLogo from "../Assets/niec-superstudent-logo.png";
import claimTicketGuide from "../Assets/claim-ticket-guide.png";
import "./ClaimTicket.css";

const APP_STORE_URL = "https://apps.apple.com/us/app/super-student/id1614354792";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=io.niec.superstudent";

const stores = [
  {
    name: "App Store",
    label: "Download on the",
    href: APP_STORE_URL,
    icon: FaApple,
    className: "is-apple",
  },
  {
    name: "Google Play",
    label: "Get it on",
    href: PLAY_STORE_URL,
    icon: FaGooglePlay,
    className: "is-android",
  },
];

function StoreCard({ store }) {
  const StoreIcon = store.icon;

  return (
    <article className={`store-card ${store.className}`}>
      <div className="store-card-heading">
        <span className="store-icon" aria-hidden="true"><StoreIcon /></span>
        <div>
          <small>{store.label}</small>
          <h2>{store.name}</h2>
        </div>
      </div>

      <a
        className="qr-link"
        href={store.href}
        target="_blank"
        rel="noreferrer"
        aria-label={`Buka halaman download Super Student di ${store.name}`}
      >
        <QRCodeCanvas
          value={store.href}
          size={220}
          level="H"
          marginSize={2}
          title={`QR code Super Student ${store.name}`}
        />
        <span>Scan QR untuk download</span>
      </a>

      <a className="store-download-button" href={store.href} target="_blank" rel="noreferrer">
        <FiDownload /> Download di {store.name} <FaArrowRight />
      </a>
    </article>
  );
}

export default function ClaimTicket() {
  const { state } = useLocation();
  const registrationEmail = state?.registrationEmail;

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="claim-ticket-page">
      <header className="claim-ticket-header">
        <div className="claim-ticket-shell">
          <Link to="/" className="claim-ticket-brand" aria-label="Kembali ke World Education Festival">
            <img src={superStudentLogo} alt="NIEC dan Super Student" />
          </Link>
          <span>World Education Festival 2026</span>
        </div>
      </header>

      <main>
        <section className="claim-ticket-hero">
          <div className="claim-ticket-shell claim-ticket-intro">
            <div className="success-mark" aria-hidden="true"><FaCheck /></div>
            <p className="claim-eyebrow">Registrasi berhasil</p>
            <h1>Satu langkah lagi untuk masuk venue!</h1>
            <p className="claim-lead">
              Registrasimu sudah tercatat, tetapi tiket masuk belum selesai diklaim. Download aplikasi
              <strong> Super Student</strong>, buat akun dan isi data diri dengan email yang sama, lalu buka menu Event untuk mengakses e-ticket.
            </p>
            {registrationEmail && (
              <div className="registered-email"><FiMail /><span>Gunakan email registrasi:</span><strong>{registrationEmail}</strong></div>
            )}

            <div className="claim-steps" aria-label="Cara mengakses tiket">
              <div><b>1</b><span><FiDownload /><strong>Download aplikasi</strong><small>Pilih App Store atau Google Play.</small></span></div>
              <div><b>2</b><span><FiMail /><strong>Buat akun dan isi data diri</strong><small>Gunakan email yang sama saat registrasi.</small></span></div>
              <div><b>3</b><span><FiSmartphone /><strong>Akses e-ticket</strong><small>Buka menu Event di Super Student.</small></span></div>
            </div>
          </div>
        </section>

        <section className="download-section" aria-labelledby="download-title">
          <div className="claim-ticket-shell">
            <div className="download-heading">
              <p className="claim-eyebrow">Claim tiketmu sekarang</p>
              <h2 id="download-title">Scan QR atau klik tombol download</h2>
              <p>Pilih sesuai perangkatmu. Link akan membuka halaman resmi aplikasi Super Student.</p>
            </div>

            <div className="store-grid">
              {stores.map((store) => <StoreCard store={store} key={store.name} />)}
            </div>

            <aside className="guide-card">
              <div>
                <p className="claim-eyebrow">Panduan lengkap</p>
                <h2>3 langkah mudah akses tiket WEF</h2>
                <p>Simpan panduan ini agar kamu tidak melewatkan langkah pembuatan akun dan akses e-ticket.</p>
              </div>
              <img src={claimTicketGuide} alt="Panduan tiga langkah akses tiket WEF melalui aplikasi Super Student" />
            </aside>

            <div className="claim-help">
              <FaCheck />
              <div><strong>Sudah download?</strong><span>Buka Super Student, daftar dengan email registrasimu, isi data diri, lalu pilih menu Event.</span></div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
